<template>
  <div>
    <el-container style="min-height:100vh">
      <el-header class="bg-white">
        <div class="TopContainer flex-space-between">
          <div class="flex flex-align-item-center">
            <div class="img cursor-pointer" @click="$router.push('/')"><img class="logo" src="/static/img/logo-home.png"/>
            </div>
            <ul class="TopHeader" v-if="flag">
              <router-link v-for="item in titleList" :key="item.title" :to="item.url">{{ item.title }}</router-link>
            </ul>
            <ul class="TopHeader" v-else>
              <router-link v-for="item in titleList2" :key="item.title" :to="item.url">{{ item.title }}</router-link>
            </ul>
          </div>
          <ul class="TopHeader">
            <li><div class="cursor-pointer" @click="loginOut">退出登录</div></li>
          </ul>
        </div>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
    <div class="footer bg-white">@光问卷</div>
  </div>
</template>

<script>
import {loginOut} from '@/api/userApi'

export default {
  name: 'login',
  data() {
    return {
      flag:false,
      titleList: [
        {
          title: '我的问卷',
          url: '/list'
        },
        {
          title: '数据账号',
          url: '/data-user'
        },
        {
          title: '用户管理',
          url: '/user'
        },{
        title: '结束页面',
          url:'/end'
        },{
          title: '操作日志',
          url:'/operation-log'
        }
        /*{
          title: '问卷类型',
          url: '/q-type-list'
        },
        {
          title: '用户管理',
          url: '/user'
        }*/
      ],
      titleList2: [
        {
          title: '我的问卷',
          url: '/list'
        },
       {
          title: '结束页面',
          url:'/end'
        }
      ],
    }
  },
  created() {
    //如果用户名不为admin，数据账号和用户管理将不会展示
    if(this.$username == 'admin'){
      this.flag = true;
    }
  },
  methods: {
    loginOut() {
      loginOut().then(res => {
        if (res.code === 200) {
          this.$message.success("退出成功")
          localStorage.removeItem("folderId")
          this.$router.push("login");
        }
      })
    },
    toUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>

.img {
  height: 60px;
  width: 150px;
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
}

.footer {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #333;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
}

.login-container .el-input input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/login.vue